import React from 'react';
import styles from './Button.module.css';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'secondary' | 'outline' | 'tab' | 'tab-secondary'; //디자인
    size?: 'small' | 'medium' | 'large'; //사이즈
    fullWidth?: boolean;
}

// 버튼
const Button: React.FC<ButtonProps> = ({
                                           children,
                                           variant = 'primary',
                                           size = 'medium',
                                           fullWidth = false,
                                           className,
                                           ...props
                                       }) => {
    return (
        <button
            className={`${styles.button} ${styles[variant]} ${styles[size]} ${fullWidth ? styles.fullWidth : ''} ${className || ''}`}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;